import { render, staticRenderFns } from "./TiktokData.vue?vue&type=template&id=84babb1a&scoped=true"
import script from "./TiktokData.vue?vue&type=script&lang=js"
export * from "./TiktokData.vue?vue&type=script&lang=js"
import style0 from "./TiktokData.vue?vue&type=style&index=0&id=84babb1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84babb1a",
  null
  
)

export default component.exports